import { Injectable } from '@angular/core';

@Injectable()
export class GoogleTagManagerService {

  constructor() { }

  initScript(): Promise<any> {
    return new Promise((resolve) => {
      const gtmScript = document.createElement('script');
      const gtmScriptGA4 = document.createElement('script');
      const gtmNoScript = document.createElement('noscript');

      gtmScript.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'}); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-W94BSQW');`;
      gtmScriptGA4.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'}); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-5THNWXP');`;
      gtmNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W94BSQW" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

      document.head.insertBefore(gtmScript, document.head.firstChild);
      document.head.insertBefore(gtmScriptGA4, document.head.lastChild);
      document.body.insertBefore(gtmNoScript, document.body.firstChild);
      resolve(null);
    });
  }

}

export function trackGAinit(googleTagManagerService: GoogleTagManagerService) {
  return () => googleTagManagerService.initScript();
}
